import script from "./KioskPaymentOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./KioskPaymentOverlay.vue?vue&type=script&setup=true&lang=js"

import "./KioskPaymentOverlay.vue?vue&type=style&index=0&id=045b7f89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045b7f89"]])

export default __exports__